var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './TransactionPage.module.css';
import { useCallback, useState } from 'react';
import { PageLayout } from '../../../Components/PageLayout';
import { ErrorIcon } from '../icons';
import styled from 'styled-components';
import { useApplication } from '../../../Contexts/ApplicationContext';
import { PaymentMethod } from '../../../../Services/methods/order';
import { FeatureFlag, useFeatureFlag, } from '../../../Contexts/FeatureFlagContext';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 64px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 64px;\n"])));
export var ErrorTransactionPage = function () {
    var orderFacade = useApplication().orderFacade;
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(false), fetchError = _b[0], setFetchError = _b[1];
    var isDirectPayment = useFeatureFlag(FeatureFlag.DIRECT_PAYMENT);
    var handleClick = useCallback(function () {
        orderFacade
            .getPaymentInfo(isDirectPayment ? PaymentMethod.DIRECT : PaymentMethod.IFRAME)
            .catch(function () {
            setFetchError(true);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [isDirectPayment, orderFacade]);
    return (_jsx(PageLayout, __assign({ hideHeaderChip: true, customBackClick: handleClick, footer: {
            actionButtonLabel: 'Try again',
            buttonClick: handleClick,
            actionButtonLoader: loading,
            actionBtnError: fetchError
                ? 'Something went wrong. Try again'
                : undefined,
        } }, { children: _jsxs(Wrapper, { children: [_jsx(ErrorIcon, {}), _jsx("h2", __assign({ className: styles.title }, { children: "Your transaction is failed" })), _jsx("p", __assign({ className: styles.text }, { children: "Your bank rejected the request or you entered incorrect card details." }))] }) })));
};
var templateObject_1;
